import * as React from 'react';

const DesktopTower = () => (
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.5 51.75H9C7.80653 51.75 6.66193 51.2759 5.81802 50.432C4.97411 49.5881 4.5 48.4435 4.5 47.25V27C4.5 25.8065 4.97411 24.6619 5.81802 23.818C6.66193 22.9741 7.80653 22.5 9 22.5H31.5"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M31.5 60.75H18"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M58.5 20.25H49.5"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M58.5 29.25H49.5"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M65.25 11.25H42.75C41.5074 11.25 40.5 12.2574 40.5 13.5V58.5C40.5 59.7426 41.5074 60.75 42.75 60.75H65.25C66.4926 60.75 67.5 59.7426 67.5 58.5V13.5C67.5 12.2574 66.4926 11.25 65.25 11.25Z"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.75 51.75V60.75"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M54 53.3244C55.187 53.3244 56.1493 52.3621 56.1493 51.1751C56.1493 49.9881 55.187 49.0259 54 49.0259C52.813 49.0259 51.8507 49.9881 51.8507 51.1751C51.8507 52.3621 52.813 53.3244 54 53.3244Z"
      fill="white"
    />
  </svg>
);

export default DesktopTower;
